import { render, staticRenderFns } from "./ResultSection.vue?vue&type=template&id=0f2fc479&"
import script from "./ResultSection.vue?vue&type=script&lang=js&"
export * from "./ResultSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports